"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchToMealPlan = exports.restoreMealPlan = exports.archiveMealPlan = void 0;
function archiveMealPlan(client, opts) {
    return client.post('archive_meal_plan', {
        meal_plan_id: opts.mealPlanId
    });
}
exports.archiveMealPlan = archiveMealPlan;
function restoreMealPlan(client, opts) {
    return client.post('restore_meal_plan', {
        meal_plan_id: opts.mealPlanId
    });
}
exports.restoreMealPlan = restoreMealPlan;
function switchToMealPlan(client, opts) {
    return client.post('switch_to_meal_plan', {
        meal_plan_id: opts.mealPlanId
    });
}
exports.switchToMealPlan = switchToMealPlan;
